export default "__VITE_ASSET__B2n0IGZ5__"